// extracted by mini-css-extract-plugin
export default {"quill":"reactquill_quill__9mmeZ"};